<template>
  <div id='ykEditor'>
    <ckeditor id='ckeditor'
              :editor='editor'
              v-model='editorData'
              :config='editorConfig'></ckeditor>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue2'
import '@ckeditor/ckeditor5-build-decoupled-document/build/translations/zh-cn'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import { getArticlesById } from '@/api/article/article'


export default {
  name: 'ClassicEditor',
  components: {
    //局部注册方式
    ckeditor: CKEditor.component
  },
  data() {
    return {
      editor: DecoupledEditor,
      editorData: '',
      editorConfig: {
        placeholder: this.placeholder,
        language: 'zh-cn'
      },
      loader: null,
      id: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    if (!this.id) {
      return
    }
    this.getArticlesById()
  },
  methods: {
    getContent() {
      return this.editorData
    },
    setContent(val) {
      this.editorData = val
    },
    getArticlesById() {
      getArticlesById(this.id).then(res => {
        if (res.data) {
          this.setContent(res.data.content)
        }
      })
    }
  }

}
</script>

<style lang='less' scoped>
/deep/ .ck-editor__editable {
  min-height: 400px;
}

/deep/ .ck-body-wrapper {
  /deep/ .ck-balloon-panel {
    z-index: 9999 !important;
  }
}
</style>

